module.exports = require("./lib/babel/polyfill");



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/polyfill.js
 ** module id = 77
 ** module chunks = 0
 **/